
export const actionsOrder = {
    methods: {
        viewOrder(obj) {
            this.$router.push({ name: 'AdminViewOrder', params: { id: obj.id} });
        },
        editOrder(obj) {
            this.$router.push({ name: 'AdminEditOrder', params: { id: obj.id} });
        },
        addOrder() {
            this.$router.push({ name: 'AdminAddOrder' });
        },
        toOrders() {
            this.$router.push({ name: 'AdminOrders' });
        },
        invoices(obj) {
            this.$router.push({ name: 'AdminInvoices', params: { query: {order_id: obj.id} } });
        },
        addInvoices(obj) {
            this.$router.push({ name: 'AdminAddInvoice', params: {orderId: obj.id, groupId: obj.group_id} });
        },
    }
};